import { getTranslation } from '@/hooks/useTranslation';

const title = getTranslation('navigation.deck') || getTranslation('nav.routes.deck.title') || 'Deck';

export default {
  title,
  headerTitle: title,
  headerBackVisible: false,
  headerShown: false,
};
